module.exports = __webpack_public_path__ + "img/car_front_left_outline.188c0339.svg";